import type { Module, Lesson } from "../types";
import level1 from "./level-1";
import level2 from "./level-2";
import level3 from "./level-3";
import level4 from "./level-4";
import level5 from "./level-5";
import level6 from "./level-6";
import level7 from "./level-7";

const ALL_MODULES: Module[] = [
  level1,
  level2,
  level3,
  level4,
  level5,
  level6,
  level7,
];

export function getAllModules(): Module[] {
  return ALL_MODULES;
}

export function getModule(moduleId: string): Module | undefined {
  return ALL_MODULES.find((m) => m.id === moduleId);
}

export function getLesson(lessonId: string): Lesson | undefined {
  for (const mod of ALL_MODULES) {
    const lesson = mod.lessons.find((l) => l.id === lessonId);
    if (lesson) return lesson;
  }
  return undefined;
}

export function getAllLessons(): Lesson[] {
  return ALL_MODULES.flatMap((m) => m.lessons);
}

export function getTotalLessonCount(): number {
  return ALL_MODULES.reduce((sum, m) => sum + m.lessons.length, 0);
}

export function getNextLesson(
  currentLessonId: string,
): Lesson | undefined {
  const allLessons = getAllLessons();
  const idx = allLessons.findIndex((l) => l.id === currentLessonId);
  if (idx === -1 || idx >= allLessons.length - 1) return undefined;
  return allLessons[idx + 1];
}
